exports = module.exports = require("../../../../../../../css-loader@1.0.1_webpack@4.44.2/node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".pf-c-popover[data-popper-reference-hidden=true]{visibility:hidden;pointer-events:none}\n", "", {"version":3,"sources":["/home/circleci/repo/node_modules/.pnpm/@patternfly+react-styles@4.92.8/node_modules/@patternfly/react-styles/css/components/Popper/Popper.css"],"names":[],"mappings":"AAAA,iDACI,kBACA,mBACJ,CAAA","file":"Popper.css","sourcesContent":[".pf-c-popover[data-popper-reference-hidden=\"true\"] {\n    visibility: hidden;\n    pointer-events: none;\n}\n\n"],"sourceRoot":""}]);

// exports
